<template>
<base-section
id="hotel-form"
>
  <v-container>
  <base-section-heading
  title="Hotel Room booking form"
  >
  <div
  style="text-align: left !important"
  >
  Please fill the following fields (First name, Last Name and Affiliation) for your room reservation at the San Servolo island during ETS 2023. Then fill the table to specify the room you want to book, the number of rooms for each type and the dates for check-in and check-out. The cost will be generated automatically. Click on the <strong>"Create Document"</strong> button below the table to generate the document that you have to send to <strong>reception@servizimetropolitani.ve.it</strong> once filled in all the fields. Please read carefully before sign.
  <strong>The firm deadline 22 February 2023.</strong><br>
  <i> Single rooms are no more available.</i>
  </div>
  <br>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <v-text-field
        label="First name"
        :rules="rules"
        required
        v-model="first"
      ></v-text-field>
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <v-text-field
        label="Last name"
        :rules="rules"
        required
        v-model="last"
      ></v-text-field>
    </v-col>
  </v-row>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <v-text-field
        label="Affiliation"
        :rules="rules"
        required
        v-model="affiliation"
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-text-field
        label="E-mail"
        :rules="rules"
        required
        v-model="email"
      ></v-text-field>
    </v-col>
  </v-row>
  </base-section-heading>
  <v-data-table
        :headers="headers"
        :items="rooms"
        :items-per-page="-1"
        item-key="id"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span
          v-html="item.name"
          >
          </span>
        </template>
        <template v-slot:[`item.qty`]="{ item }">
          <v-select
          :items="options"
          label="Number of rooms"
          @change="compute"
          v-model="item.qty"
          ></v-select>
        </template>
        <template v-slot:[`item.checkin`]="{ item }">
          <v-select
          :items="checkinopt"
          label="Date"
          @change="compute"
          v-model="item.checkindate"
          ></v-select>
        </template>
        <template v-slot:[`item.checkout`]="{ item }">
          <v-select
          :items="checkoutopt"
          label="Date"
          @change="compute"
          v-model="item.checkoutdate"
          ></v-select>
        </template>
        <template v-slot:[`item.nights`]="{ item }">
          {{ item.nights }}
        </template>
        <template v-slot:[`item.cost`]="{ item }">
          {{ item.cost }}
        </template>
         <template slot="body.append">
          <tr>
            <td colspan="2"><strong>Grand Total</strong></td>
            <td>{{ this.room }}</td>
            <td colspan="1"><strong>Advance Payment<span style="color:red;">*</span></strong></td>
            <td colspan="1">{{ this.advance }}</td>
            <td><strong>Total Overall Cost</strong>
            <td>{{ this.total }}</td>
          </tr>
        </template>
      </v-data-table>
      <br>
    <base-section-heading
    divider="null"
    >
    <div
    style="text-align: left !important;"
    >
    <strong><span style="color:red;">*</span> San Servolo Hotel requires the advance payment of the first night per room at reservation time. The remaining part is paid on-site together with a city tax of 4,00€ per night. Breakfast is not included. On receipt of the generated document the hotel will immediately debit your credit card for the cost of the first night.
    IMPORTANT: This down payment is not refundable under any circumstances. The balance owed at the end of your stay must be settled at check-in. </strong>
    <br>
    <br>
    </div>
    <btn
    @click="handleGenerate"
    >
    Create document
    </btn>
    <br>
    <br>
    <v-alert
    type="error"
    dismissible
    v-show="valid"
    >
    Please check if the dates for check-in and check-out are valid and/or if at least one room is selected and/or if the fields regarding First Name, Last Name and Affiliation are filled.
    </v-alert>
    <br>
    <div
    style="text-align: left !important;"
    >
    <strong>Please indicate your credit card details inside the document (American Express and Diners not accepted).</strong>
    <br>
    Alternatively, you can pay by bank transfer to the following bank account*
    <br>
    <strong>
    San Servolo Servizi <br>
    Banca Intesa – Gruppo Intesa San Paolo <br>
    Filiale di Venezia San Leonardo (0642) <br>
    Cannaregio 1353, 30121 Venezia <br>
    IBAN: IT97 L030 6902 1271 0000 0002 312 <br>
    BIC: BCITITMM <br>
    </strong>

    *In case you pay by bank transfer, please send the payment receipt together with the document filled
    <br>
    <br>
    <strong>By signing the document you acknowledge and accept that: </strong><br>
a)	Available rooms will be assigned on a first-come-first-served basis. If the type of room requested is not available, a room of a different type will be assigned at the prices indicated above.  <br>
b)	Cancellations or curtailment of initial booking: <br>
&emsp;-	<u>Cancellations or curtailments made between 90 and 60 days before arrival</u>: apart from the deposit for the first night, which is not refundable, no further penalties will apply for the cancellation of up to 20 % of the total number of room-nights. For the cancellation of more than 20 % of room-nights, a penalty of 60% of the price of the cancelled nights will be debited to your credit card; <br>
&emsp;-	<u>Cancellations or curtailments made more between 59 and 30 days before the check-in date</u>: apart from the deposit for the first night, which is not refundable, no penalties will apply for the cancellation of up to 10 % of the total number of room-nights. For the cancellation of more than 10 % of the total number of room-nights, a penalty of 60% of the price of the cancelled nights will be debited to your credit card; <br>
&emsp;-	<u>Cancellations or curtailments made between 29 and the check-in date</u>: a penalty of 100% of the total price of the booking will be debited to your credit card. <br>
    <br>
    <br>
    <strong><span style="background-color:lightgreen;color:black;">Once filled, please send the generated document scanned to the following email address:</span></strong>
    <h1>reception@servizimetropolitani.ve.it</h1>
    </div>
    <br>
    <br>
    <v-alert
    type="info"
    >
    All data that you enter are not stored and are used for the only purpose of generating the document.
    </v-alert>
    <br>
    <br>
    If you have any problem in the generation of the document please contact: <strong>giusy.iaria@polito.it</strong>
    </base-section-heading>
  </v-container>
</base-section>
</template>

<script>
import Btn from '../../components/base/Btn.vue';
import { jsPDF } from "jspdf";

export default {
  components: { Btn },
  data() {
    return {
      rules: [
        v => !!v || 'Required',
      ],
      valid: false,
      quantity: '',
      checkindate: '',
      checkoutdate: '',
      total: '0',
      advance: '0',
      price: 148.75,
      room: '0',
      email: '',
      first: '',
      last: '',
      address: '',
      dob: '',
      idcard: '',
      affiliation: '',
      options: [
        '0', '1', '2', '3', '4',
      ],
      checkinopt: [
        'May 22, 2023', 'May 23, 2023', 'May 24, 2023', 'May 25, 2023',
      ],
      checkoutopt: [
        'May 23, 2023', 'May 24, 2023', 'May 25, 2023', 'May 26, 2023', 'May 27, 2023',
      ],
      headers: [
        {
          text: 'Type of Room',
          value: 'name',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Price/day [€]',
          value: 'price',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Number of rooms',
          value: 'qty',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Check-in',
          value: 'checkin',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Check-out',
          value: 'checkout',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Number of nights',
          value: 'nights',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Overall cost [€]',
          value: 'cost',
          sortable: false,
          align: 'left',
        },
      ],
      rooms: [
        {
          name: '<strong>Double Deluxe Superior room - lagoon view</strong><br>(King size bed - max occupancy 2 persons)',
          real: 'Double Deluxe Superior room - lagoon view (King size bed - max occupancy 2 persons)',
          price: '148.75',
          qty: '',
          checkin: '',
          checkout: '',
          nights: '0',
          cost: '0',
          id: '1',
        },
        {
          name: '<strong>Junior Suite</strong><br>(King size bed - max occupancy 2 persons)',
          real: 'Junior Suite (king size bed - max occupancy 2 persons)',
          price: '170.00',
          qty: '',
          checkin: '',
          checkout: '',
          nights: '0',
          cost: '0',
          id: '2',
        },
        {
          name: '<strong>Double Room</strong><br>(two single beds - max occupancy 2 persons)',
          real: 'Double Room (two single beds - max occupancy 2 persons)',
          price: '127.50',
          qty: '',
          checkin: '',
          checkout: '',
          nights: '0',
          cost: '0',
          id: '3',
        },
        {
          name: '<strong>Single Room</strong>',
          real: 'Single Room',
          price: '80.75',
          qty: '',
          checkin: '',
          checkout: '',
          nights: '0',
          cost: '0',
          id: '4',
        },
        {
          name: '<strong>Triple Room</strong><br>(double use)',
          real: 'Triple Room (double use)',
          price: '127.50',
          qty: '',
          checkin: '',
          checkout: '',
          nights: '0',
          cost: '0',
          id: '5',
        },
        {
          name: '<strong>Triple Room</strong><br>(triple use)',
          real: 'Triple Room (triple use)',
          price: '148.50',
          qty: '',
          checkin: '',
          checkout: '',
          nights: '0',
          cost: '0',
          id: '6',
        },
      ],
    };
  },
  methods: {
    compute() {
      this.total = 0
      this.advance = 0
      this.room = 0
      this.rooms.forEach(room => {
        if (room.checkoutdate !== undefined && room.checkindate !== undefined && room.qty !== undefined) {
          room.nights = room.checkoutdate.split(",")[0].split(" ")[1] - room.checkindate.split(",")[0].split(" ")[1]
          room.cost = room.nights * room.qty * room.price
          this.total += room.cost
          this.advance += room.qty * room.price
          this.room += 1
          room.cost = room.cost.toString()
        }
      })
    },
    validate() {
      var toCheck = []
      this.rooms.forEach(room => {
        if (room.qty !== undefined && room.qty > 0) {
          toCheck.push(room)
        }
      })
      if (toCheck.length > 0) {
        for (let i = 0; i < toCheck.length; i++) {
          if (toCheck[i].cost < 0) {
            return false
          }
        }
      } else {
        return false
      }
      if (this.first === '' || this.last === '' || this.affiliation === '' || this.email === '') {
        return false
      }
      return true
    },
    handleGenerate() {
      if (this.validate()) {
        this.createDocument()
        this.valid = false
      } else {
        this.valid = true
      }
    },
    createDocument() {
      var doc = new jsPDF({ putOnlyUsedFonts: true });
      doc.setFontSize(22);
      var y = 20
      doc.text("San Servolo hotel rooms booking form", 20, y);
      y += 10
      doc.setFontSize(10);
      var entire = "Please fill all the blank fields for your room reservation at the San Servolo Island during ETS23 conference"
      var split = doc.splitTextToSize(entire, 165)
      doc.text(split, 20, y);
      y += 7

      doc.setFont("helvetica", "bold");
      doc.text("Firm deadline: 22 February 2023", 20, y)
      y += 7
      doc.setFont("helvetica", "normal")

      doc.text("First and last name: " + this.first + " " + this.last, 20, y)
      y += 6
      doc.text("Affiliation: " + this.affiliation, 20, y)
      y += 6
      doc.text("E-mail address: " + this.email, 20, y)
      y += 6
      doc.text("Address: " + this.address, 20, y)
      y += 6
      doc.text("Place and date of birth: " + this.dob, 20, y)
      y += 6
      doc.text("ID Card/Passport Number: " + this.idcard, 20, y)

      var table_height = y

      doc.setFont("helvetica", "bold")
      doc.text("Advance Payment*:", 20, table_height + 15)
      doc.setFont("helvetica", "normal")
      doc.text("" + this.advance + "€", 20, table_height + 22)
      doc.setFont("helvetica", "bold")
      doc.text("Overall cost:", 20, table_height + 30)
      doc.setFont("helvetica", "normal")
      doc.text("" + this.total + "€", 20, table_height + 37)

      var reportTitle = "*San Servolo Hotel requires the advance payment of the first night per room at reservation time. The remaining part is paid on-site together with a city tax of 4,00€ per night. Breakfast is not included. On receipt of this document we will immediately debit your credit card for the cost of the first night."
      var splitTitle = doc.splitTextToSize(reportTitle, 170);
      doc.text(splitTitle, 20, table_height + 47)
      table_height = table_height + 47 + (10 * (splitTitle.length - 1))
      doc.setFont("helvetica", "bold")
      reportTitle = "IMPORTANT: This down payment is not refundable under any circumstances. The balance owed at the end of your stay must be settled at check-in."
      splitTitle = doc.splitTextToSize(reportTitle, 165);
      doc.text(splitTitle, 20, table_height)
      table_height += (10 * (splitTitle.length - 1))

      doc.setFont("helvetica", "normal")
      function createHeaders(keys, names) {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
          result.push({
            id: keys[i],
            name: keys[i],
            prompt: names[i],
            width: 44,
            align: "center",
            padding: 0,
          });
        }
        return result;
      }

      var rooms_data = [];
      this.rooms.forEach(data => {
        if (data.cost !== undefined && data.qty !== undefined && data.qty > 0 && data.checkindate !== undefined && data.checkoutdate !== undefined) {
          //  rooms_data.push(Object.assign({}, data));
          rooms_data.push(data)
        }
      })

      var headers = createHeaders([
        "real",
        "qty",
        "checkindate",
        "checkoutdate",
        "cost",
      ], [
        "Type of room",
        "Number of rooms",
        "Check-in",
        "Check-out",
        "Cost [€]",
      ]);

      doc.setFontSize(7);
      doc.table(20, table_height, rooms_data, headers, { fontSize: 9 });

      doc.addPage()
      doc.setFontSize(10)
      doc.setLineWidth(0.5)

      y = 20
      doc.line(15, y, 190, y)
      y += 10
      entire = "Please indicate your credit card details below (American Express and Diners not accepted):"
      split = doc.splitTextToSize(entire, 170)
      doc.text(split, 20, y)
      y += (10 * (split.length))

      doc.text("[  ] VISA     [  ] MASTERCARD", 20, y)

      y += 10

      doc.setFont("helvetica", "bold")
      doc.text("Card number: ", 20, y)
      y += 6
      doc.text("Expiry date: ", 20, y)
      y += 6
      doc.text("First and last name on the card: ", 20, y)
      y += 6
      doc.text("Signature of the card holder: ", 20, y)
      y += 8

      doc.line(15, y, 190, y)
      y += 10
      doc.setFont("helvetica", "normal")

      doc.text("Alternatively, you can pay by bank transfer to the following bank account*:", 20, y)
      y += 10

      doc.setFont("helvetica", "bold")
      doc.text("San Servolo Servizi", 20, y)
      y += 6
      doc.text("Banca Intesa – Gruppo Intesa San Paolo", 20, y)
      y += 6
      doc.text("Filiale di Venezia San Leonardo (0642)", 20, y)
      y += 6
      doc.text("Cannaregio 1353, 30121 Venezia", 20, y)
      y += 6
      doc.text("IBAN: IT97 L030 6902 1271 0000 0002 312", 20, y)
      y += 6
      doc.text("BIC: BCITITMM", 20, y)
      y += 8

      doc.setFont("helvetica", "italic")
      doc.text("*In case you pay by bank transfer, please send the payment receipt together with this module filled", 20, y)
      y += 10
      doc.setFont("helvetica", "bold")

      doc.line(15, y, 190, y)
      y += 10

      doc.text("By signing this form you acknowledge and accept that:", 20, y)
      y += 7
      doc.setFont("helvetica", "normal")
      entire = "a)	Available rooms will be assigned on a first-come-first-served basis. If the type of room requested is not available, a room of a different type will be assigned at the prices indicated above."
      split = doc.splitTextToSize(entire, 160)
      doc.text(split, 20, y)
      y += (5 * (split.length))

      doc.text("b)	Cancellations or curtailment of initial booking:", 20, y)
      y += 6

      doc.setFont("helvetica", "bold")
      doc.text("-	Cancellations or curtailments made between 90 and 60 days before arrival", 25, y)
      doc.setFont("helvetica", "normal")
      y += 6
      entire = "Apart from the deposit for the first night, which is not refundable, no further penalties will apply for the cancellation of up to 20 % of the total number of room-nights. For the cancellation of more than 20 % of room-nights, a penalty of 60% of the price of the cancelled nights will be debited to your credit card;"
      split = doc.splitTextToSize(entire, 160)
      doc.text(split, 25, y)
      y += (5 * (split.length))

      doc.setFont("helvetica", "bold")
      doc.text("-	Cancellations or curtailments made more between 59 and 30 days before the check-in date:", 25, y)
      doc.setFont("helvetica", "normal")
      y += 6
      entire = "Apart from the deposit for the first night, which is not refundable, no penalties will apply for the cancellation of up to 10 % of the total number of room-nights. For the cancellation of more than 10 % of the total number of room-nights, a penalty of 60% of the price of the cancelled nights will be debited to your credit card;"
      split = doc.splitTextToSize(entire, 160)
      doc.text(split, 25, y)
      y += (5 * (split.length))

      doc.setFont("helvetica", "bold")
      doc.text("-	Cancellations or curtailments made between 29 and the check-in date: ", 25, y)
      doc.setFont("helvetica", "normal")
      y += 6

      doc.text("A penalty of 100% of the total price of the booking will be debited to your credit card. ", 25, y)
      y += 18

      doc.text("Signature for acceptance    ___________________________", 90, y)
      y += 20

      doc.setFontSize(12)
      doc.setFillColor(102, 255, 153)
      doc.setFont("helvetica", "bold")
      doc.rect(30, y - 4, 155, 6, "F")
      doc.text("Once filled, please send this module scanned to the following email address:", 30, y)
      y += 6
      doc.setFillColor(0, 0, 0)
      doc.setTextColor(0, 150, 255)
      doc.setFontSize(14)
      doc.text("reception@servizimetropolitani.ve.it", 60, y)

      doc.save("booking_form_san_servolo")
    },
  },
};
</script>
